import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

import { v4 as uuidv4 } from "uuid";
import Moment from "moment";
import Translate from "components/translate";

import RFSInfo from "../Components/RFSInfo";
import Input from "components/react-validation/components/input";
import Form from "components/react-validation/components/form";
import Textarea from "../../components/react-validation/components/text-area";
import Submit from "../../components/react-validation/components/submit";
import Datetime from "react-datetime";
import Dropzone from "react-dropzone";
import { Dropdown } from "../../components/Dropdown/Dropdown";
import { CheckBoxSingle } from "../../components/checkboxes/check-box-single";
import { isEmpty } from "lodash";

import * as LotActionType from "../../Lots/constants";
import * as WOTActionType from "../../Work-Order-Type/constants";
import * as TradeActionType from "../../Trades/constants";
import * as ItemActionType from "../../Items/constants";
import * as SubcontractorActionType from "../../Subcontractors/constants";
import * as ProjectActionType from "../../Projects/constants";
import * as WorkOrderActionType from "../constants";
import * as NotifyActionType from "../../Notification/constants";
import * as Vali from "helper/validator-helper";
import * as RFSActionType from "../../Request-Services/constants";
import ImageConvertor from "../../utils/ImageConvertor";
import * as DefaultConfigActionType from "../../DefaultConfig/constants";
/**
 * NOTE: params isRedirect alway is true (I dont know this variable using for what???) and
 * using isCheckAnotherProblem in state local for handle redirect to edit
 */

const MAXIMUM_FILE_SIZE = 1024 * 1024 * 10; //10MB
let counter = 1;
var yesterday = Moment().subtract(1, "day");
var isValidAppointmentDate = function (current) {
  return current.isAfter(yesterday);
};
class AddWorkOrder extends Component {
  static propTypes = {
    dispatch: PropTypes.func,
    toggleModal: PropTypes.func,
    match: PropTypes.object,
    history: PropTypes.object,
    location: PropTypes.object,
    workOrderTypeList: PropTypes.any,
    TradeList: PropTypes.any,
    ItemRepairList: PropTypes.any,
    ProblemList: PropTypes.any,
    RoomList: PropTypes.any,
    SubcontractorList: PropTypes.any,
    UserList: PropTypes.any,
    ManagerStore: PropTypes.object,
    IsRedirectToEdit: PropTypes.object,
    ManageWorkOrderTypes: PropTypes.object,
    UserProfile: PropTypes.object,
    DefaultConfigList: PropTypes.array,
  };

  constructor(props) {
    super(props);

    let rfsId = null;

    if (props.match.params.RFSID) {
      rfsId = props.match.params.RFSID;
    }

    this.state = {
      isFetchTrade: false,
      check: false,
      lotStatus: null,
      wot: null,
      trade: null,
      itemRepair: null,
      problem: null,
      room: null,
      subcontractor: null,
      user: null,
      userList: [],

      rfsId: rfsId,
      isCheckAnotherProblem: false,
      appointmentDate: null,

      isModeAssignSub: true,
      isInitialUser: false,
      isLoadingLocation: false,
      isLoadingTrade: false,
      isLoadingSubcontractor: false,
      isLoadingUser: false,
      isLoadingItemToRepair: false,
      isLoadingProblem: false,
      isLoadingWorkOrderType: false,
      error: null,
      formErrors: {},
      files: [],
      isDisabled: false,
    };
    this.appointmentDateRef = React.createRef();
  }

  componentDidMount() {
    counter = 1;
    this.fetchLotPaidFeature();
    this.fetchDetailRfs();
    // this.getDefaultConfigData();
    this.props.dispatch({
      type: WorkOrderActionType.SET_IS_REDIRECT_WORK_ORDER_FALSE,
    });
  }

  fetchLotPaidFeature = () => {
    this.props.dispatch({
      type: WorkOrderActionType.GET_LOT_PAID_FEATURE,
      callback: (data, success) => {
        if (success && data && data.data && data.data.length > 0) {
          this.setState({ lotStatus: data.data[0].lotStatus });
        } else {
          console.log("🚀 ~ Callback failed or no data:", { data, success });
        }
      },
    });
  };

  getDefaultConfigData = async () => {
    await this.props.dispatch({
      type: DefaultConfigActionType.GET_DEFAULT_CONFIG_FOR_DROPDOWN,
      params: null,
      callback: (data) => {
        if (data) {
          this.fetchWOT();
          this.fetchRoom();
          this.fetchTrade();
        }
      },
    });
  };
  componentWillReceiveProps(nextProps) {
    if (
      nextProps.ManagerStore &&
      nextProps.ManagerStore.RFSProfile &&
      nextProps.ManagerStore.RFSProfile.managedByUser &&
      !this.state.isInitialUser
    ) {
      this.setState({
        user: {
          value: nextProps.ManagerStore.RFSProfile.managedByUser.id,
          text: `${nextProps.ManagerStore.RFSProfile.managedByUser.displayName} (${nextProps.ManagerStore.RFSProfile.managedByUser.email})`,
          extensionValue: {
            email: nextProps.ManagerStore.RFSProfile.managedByUser.email,
          },
          selected: false,
        },
        defaultUser: {
          value: nextProps.ManagerStore.RFSProfile.managedByUser.id,
          text: `${nextProps.ManagerStore.RFSProfile.managedByUser.displayName} (${nextProps.ManagerStore.RFSProfile.managedByUser.email})`,
          extensionValue: {
            email: nextProps.ManagerStore.RFSProfile.managedByUser.email,
          },
          selected: false,
        },
        isInitialUser: true,
      });
    }
    if (nextProps.IsRedirectToEdit.isRedirect) {
      if (this.state.isCheckAnotherProblem) {
        this.onResetForm();
        console.log("Reset form...", this.state);
      } else {
        this.props.history.push(
          `/request-for-services/work-order/detail/${this.state.rfsId}/${nextProps.IsRedirectToEdit.refNo}`
        );
      }
    }

    if (nextProps.RoomList) {
      this.setState({ isLoadingLocation: false });
    }
    if (nextProps.TradeList) {
      this.setState({ isLoadingTrade: false });
    }
    if (nextProps.SubcontractorList) {
      this.setState({ isLoadingSubcontractor: false });
    }
    if (nextProps.UserList) {
      this.setState({ isLoadingUser: false });
    }
    if (nextProps.ItemRepairList) {
      this.setState({ isLoadingItemToRepair: false });
    }
    if (nextProps.ProblemList) {
      this.setState({ isLoadingProblem: false });
    }
    if (nextProps.workOrderTypeList) {
      this.setState({ isLoadingWorkOrderType: false });
    }
  }

  onResetForm = () => {
    const dropdownRefs = [
      "itemRepairDropdown",
      "userDropdown",
      "subcontractorDropdown",
      "problemDropdown",
      "tradeDropdown",
      "wotDropdown",
    ];

    dropdownRefs.map((item) => {
      if (this[item] && this[item].resetValidate) {
        this[item].resetValidate();
      }
    });
    const wot =
      this.props.ManagerStore.RFSProfile.requestType.type === 3
        ? this.state.wot
        : null;

    this.setState({
      // wot: wot,
      // trade: null,
      // itemRepair: null,
      // problem: null,
      // room: null,
      subcontractor: null,
      user: null,
      appointmentDate: null,
      isCheckAnotherProblem: false,
      files: [],
      errorFile: null,
      isDisabled: false, // No additional check for disabling . isDisabled was added while submitting
    });

    this.appointmentDateRef.current = null;

    if (this.form) {
      this.form.resetForm(this.refs);
    }

    this.props.dispatch({
      type: WorkOrderActionType.SET_IS_REDIRECT_WORK_ORDER_FALSE,
    });
  };

  fetchDetailRfs() {
    this.props.dispatch({
      type: RFSActionType.GET_BY_RFS_ID_ASYNC,
      params: this.state.rfsId,
      callback: () => {
        this.getDefaultConfigData();
      },
      onError: () => {
        this.getDefaultConfigData();
        setTimeout(() => {
          this.props.dispatch({
            type: RFSActionType.GET_BY_RFS_ID_ASYNC,
            params: this.state.rfsId,
          });
        }, 3000);
      },
    });
  }

  onClickCreatenSendButton = (e) => {
    e.preventDefault();

    if (isEmpty(this.state.files)) {
      this.createAndSend();
    } else {
      this.createAndSend();
      // this.uploadAttachmentsToS3(this.state.files, this.createAndSend);
    }
  };

  createAndSend = (uploadedFiles = []) => {
    const formValues = this.form.getValues();
    const {
      room,
      trade,
      wot,
      subcontractor,
      user,
      itemRepair,
      problem,
      rfsId,
      appointmentDate,
      isModeAssignSub,
    } = this.state;

    // Check enough info for create and send
    let assignedUserId = null;
    let subcontractorId = null;
    let validateUser = true;
    let validateSubcontractor = true;

    if (isModeAssignSub) {
      subcontractorId = subcontractor ? subcontractor.value : null;
      validateSubcontractor = this.subcontractorDropdown.validate();
    } else {
      assignedUserId = user ? user.value : null;
      validateUser = this.userDropdown.validate();
    }

    const validateWot = this.wotDropdown.validate();
    const validateProblem = this.problemDropdown.validate();
    const validateItemRepair = this.itemRepairDropdown.validate();
    const validateTrade = this.tradeDropdown.validate();

    if (
      !validateUser ||
      !validateSubcontractor ||
      !validateWot ||
      !validateProblem ||
      !validateItemRepair ||
      !validateTrade
    ) {
      return false;
    }

    // Build params and dispatch
    const params = {
      title: formValues.title,
      description: formValues.description,
      requestId: rfsId,
      tradeId: trade ? trade.value : null,
      roomId: room.value,
      itemToRepairId: itemRepair ? itemRepair.value : null,
      subcontractorId: subcontractorId,
      assignedUserId: assignedUserId,
      workOrderTypeId: wot ? wot.value : null,
      problemId: problem ? problem.value : null,
      appointmentDate: appointmentDate
        ? Moment(appointmentDate).format()
        : null,
      // attachments: uploadedFiles.map((f) => ({
      //   url: f.Location,
      //   key: f.Key,
      //   fileName: f.name,
      // })),
    };

    this.props.dispatch({
      type: WorkOrderActionType.CREATE_AND_SEND_WORK_ORDER_ASYNC,
      params: {
        data: params,
        isRedirectToEdit: false,
      },
      callback: (workorder) => {
        if (this.state.files.length > 0) {
          this.uploadAttachmentsToS3(this.state.files, workorder);
        } else {
          this.props.dispatch({
            type: WorkOrderActionType.CREATE_WORK_ORDER_SUCCESS,
            data: {
              isRedirect: true,
              refNo: workorder.refNo,
              workOrderProfile: workorder,
            },
          });
          this.props.dispatch({
            type: NotifyActionType.NOTIFY_SUCCESS,
            data: "Work order created",
          });
        }
      },
    });

    return true;
  };

  isDisabledBtn = () => {
    let isDisabled = true;
    if (this.form) {
      const { room, error } = this.state;
      const formValues = this.form.getValues();
      const { title, description } = formValues;
      isDisabled = !room || error || !title || !description;
    }
    this.setState({
      isDisabledAnotherBtn: isDisabled,
    });
  };

  onSelectChange = (event, name) => {
    this.setState({
      [name]: event.value,
    });
    if (name === "itemRepair") {
      this.setState({
        problem: null,
      });
    }
    if (name === "trade") {
      this.setState({
        subcontractor: null,
        itemRepair: null,
        problem: null,
      });
    }
  };

  onChangeAppointmentDate = (appointmentDate) => {
    if (appointmentDate) {
      if (appointmentDate._i <= appointmentDate._d) {
        if (Moment(appointmentDate, "MM/DD/YYYY hh:mm A", true).isValid()) {
          this.setState({
            appointmentDate,
            error: null,
          });
        } else {
          this.setState({
            error: "Invalid datetime.",
          });
        }
      } else {
        var selectedTime = Moment(appointmentDate._d, "MM/DD/YYYY hh:mm A");
        this.setState({
          appointmentDate: Moment(new Date()).set({
            hour: selectedTime.hour(),
            minute: selectedTime.minute(),
          }),
          error: null,
        });
      }
    } else {
      this.setState({
        appointmentDate,
        error: null,
      });
    }
  };

  fetchSelectRoom = () => {
    this.setState({ isLoadingLocation: true });
    this.props.dispatch({
      type: LotActionType.SELECT_ROOM_ASYNC,
      params: {
        id: this.props.ManagerStore.RFSProfile.lot.id,
        searchKey: "",
        selectedValue: "",
        includeSystemRoom: true,
      },
    });
  };

  fetchRoom = () => {
    this.setState({ isLoadingLocation: true });
    this.props.dispatch({
      type: LotActionType.SELECT_ROOM_ASYNC,
      params: {
        id: this.props.ManagerStore.RFSProfile.lot.id,
        searchKey: "",
        selectedValue: "",
        includeSystemRoom: true,
      },
      callback: (data) => {
        if (this.props.DefaultConfigList.length > 0) {
          this.props.DefaultConfigList.map((defaultItem) => {
            data.map((roomItem) => {
              if (defaultItem.propertyValue === roomItem.value) {
                this.setState({ room: roomItem });
              }
            });
          });
        }
      },
    });
  };

  fetchSelectTrade = () => {
    this.setState({ isLoadingTrade: true });
    this.props.dispatch({
      type: LotActionType.SELECT_TRADE_ASYNC,
      params: {
        id: this.props.ManagerStore.RFSProfile.lot.id,
        searchKey: "",
        selectedValue: "",
        setDefaultSelected: false,
      },
    });
  };

  fetchTrade = () => {
    this.setState({ isLoadingTrade: true });
    this.props.dispatch({
      type: LotActionType.SELECT_TRADE_ASYNC,
      params: {
        id: this.props.ManagerStore.RFSProfile.lot.id,
        searchKey: "",
        selectedValue: "",
        setDefaultSelected: false,
      },
      callback: (res) => {
        const propertyData = ["RFSTrade"];
        if (this.props.DefaultConfigList.length > 0) {
          this.props.DefaultConfigList.map((defaultItem) => {
            res.map((tradeItem) => {
              if (
                defaultItem.propertyValue === tradeItem.value &&
                propertyData.includes(defaultItem.propertyName)
              ) {
                this.setState({ trade: tradeItem });
                this.fetchItemRepair();
              }
            });
          });
        }
      },
    });
  };

  fetchSelectedWOT = () => {
    this.setState({ isLoadingWorkOrderType: true });
    this.props.dispatch({
      type: WOTActionType.SELECT_LIST_WOT_ASYNC,
      params: {
        searchKey: "",
        selectedValue: "",
        setDefaultSelected: false,
      },
    });
  };

  fetchWOT = () => {
    this.setState({ isLoadingWorkOrderType: true });
    this.props.dispatch({
      type: WOTActionType.SELECT_LIST_WOT_ASYNC,
      params: {
        searchKey: "",
        selectedValue: "",
        setDefaultSelected: false,
      },
      callback: (data) => {
        if (this.props.DefaultConfigList.length > 0) {
          this.props.DefaultConfigList.map((defaultItem) => {
            data.map((wotItem) => {
              if (defaultItem.propertyValue === wotItem.value) {
                this.setState({ wot: wotItem });
              }
            });
          });
        }
      },
    });
  };

  fetchSelectItemRepair = () => {
    if (this.state.trade) {
      this.setState({ isLoadingItemToRepair: true });
      this.props.dispatch({
        type: TradeActionType.SELECT_LIST_ITEM_REPAIR_BY_TRADEID_ASYNC,
        params: {
          id: this.state.trade.value,
          searchKey: "",
          selectedValue: "",
          setDefaultSelected: false,
        },
      });
    }
  };

  fetchItemRepair = () => {
    if (this.state.trade) {
      this.setState({ isLoadingItemToRepair: true });
      this.props.dispatch({
        type: TradeActionType.SELECT_LIST_ITEM_REPAIR_BY_TRADEID_ASYNC,
        params: {
          id: this.state.trade.value,
          searchKey: "",
          selectedValue: "",
          setDefaultSelected: false,
        },
        callback: (data) => {
          const propertyData = ["RFSItemToRepair"];
          if (this.props.DefaultConfigList.length > 0) {
            this.props.DefaultConfigList.map((defaultItem) => {
              this.props.ItemRepairList.map((itemtorepairItem) => {
                if (
                  defaultItem.propertyValue === itemtorepairItem.value &&
                  propertyData.includes(defaultItem.propertyName)
                ) {
                  this.setState({ itemRepair: itemtorepairItem });
                  this.fetchProblem();
                }
              });
            });
          }
        },
      });
    }
  };

  fetchSubcontractor = () => {
    if (this.state.trade) {
      this.setState({ isLoadingSubcontractor: true });
      this.props.dispatch({
        type: SubcontractorActionType.SELECT_LIST_SUBCONTRACTOR_ASYNC,
        params: {
          projectId: this.props.ManagerStore.RFSProfile.project.id,
          lotId: this.props.ManagerStore.RFSProfile.lot.id,
          tradeId: this.state.trade.value,
          param: {
            searchKey: "",
            selectedValue: "",
          },
        },
      });
    }
  };

  fetchUser = () => {
    this.setState({ isLoadingUser: true });
    this.props.dispatch({
      type: ProjectActionType.GET_LIST_USER_ASYNC,
      params: {
        projectId: this.props.ManagerStore.RFSProfile.project.id,
      },
      callback: () => {
        this.setState({ isFetchedUser: true });
      },
    });
  };

  fetchSelectProblem = () => {
    if (this.state.itemRepair) {
      this.setState({ isLoadingProblem: true });
      this.props.dispatch({
        type: ItemActionType.SELECT_LIST_PROBLEM_ASYNC,
        params: {
          id: this.state.itemRepair.value,
          searchKey: "",
        },
      });
    }
  };

  fetchProblem = () => {
    if (this.state.itemRepair) {
      this.setState({ isLoadingProblem: true });
      this.props.dispatch({
        type: ItemActionType.SELECT_LIST_PROBLEM_ASYNC,
        params: {
          id: this.state.itemRepair.value,
          searchKey: "",
        },
        callback: (data) => {
          const propertyData = ["RFSProblem"];
          if (this.props.DefaultConfigList.length > 0) {
            this.props.DefaultConfigList.map((defaultItem) => {
              data.map((problemItem) => {
                if (
                  defaultItem.propertyValue === problemItem.value &&
                  propertyData.includes(defaultItem.propertyName)
                ) {
                  this.setState({ problem: problemItem });
                }
              });
            });
          }
        },
      });
    }
  };

  onSelect = () => {
    this.upload.upload();
  };
  //oncheck for checkbox in add working-order
  onChecked = () => {
    this.setState({
      isCheckAnotherProblem: !this.state.isCheckAnotherProblem,
      // using this for reset the form to add another
      // isCheckAnotherProblem: true
    });
  };

  handleCancel = () => {
    this.props.history.push(`/request-for-services/${this.state.rfsId}`);
  };

  handleModeAssign = (mode) => {
    if (mode === "sub") {
      this.setState({ isModeAssignSub: true, user: this.state.defaultUser });
    } else {
      this.setState({ isModeAssignSub: false, subcontractor: null });
    }
  };

  renderInternalUserDropdown = () => {
    if (this.props.UserProfile.sso) {
      return (
        <Dropdown
          onChange={(ref) => {
            this.onSelectChange(ref, "user");
          }}
          filter={true}
          className="filestring-dropdown filter-dropdown"
          onRemote={this.fetchUser}
          options={
            this.state.isFetchedUser
              ? this.props.UserList.map((item) => {
                  return {
                    ...item,
                    text: `${item.text} (${item.extensionValue.email})`,
                  };
                })
              : [{ ...this.state.user }]
          }
          loading={this.state.isLoadingUser}
          optionLabel="text"
          errorMessage="This information is required."
          value={this.state.user}
          showClear={true}
          groupLabels={[
            {
              label: "System users",
              field: "sso",
              condition: [true],
            },
            {
              label: "Builder users",
              field: "sso",
              condition: [false, null],
            },
          ]}
          name="user"
          placeholder="-- Select a user"
          ref={(ref) => {
            this.userDropdown = ref;
          }}
          style={{ width: "100%", paddingLeft: 15 }}
        />
      );
    }
    return (
      <Dropdown
        onChange={(ref) => {
          this.onSelectChange(ref, "user");
        }}
        filter={true}
        className="filestring-dropdown filter-dropdown"
        onRemote={this.fetchUser}
        options={
          this.state.isFetchedUser
            ? this.props.UserList.map((item) => {
                return {
                  ...item,
                  text: `${item.text} (${item.extensionValue.email})`,
                };
              })
            : [{ ...this.state.user }]
        }
        loading={this.state.isLoadingUser}
        optionLabel="text"
        errorMessage="This information is required."
        value={this.state.user}
        showClear={true}
        name="user"
        placeholder="-- Select a user"
        ref={(ref) => {
          this.userDropdown = ref;
        }}
        style={{ width: "100%", paddingLeft: 15 }}
      />
    );
  };

  onSubmit = (e) => {
    e.preventDefault();
    this.setState({ isDisabled: true }, () => {
      try {
        this.createOrder();
      } catch (e) {
        this.setState({ isDisabled: false });
      }
    });
  };

  createOrder = () => {
    const formValues = this.form.getValues();
    const {
      room,
      trade,
      wot,
      subcontractor,
      user,
      itemRepair,
      problem,
      rfsId,
      appointmentDate,
      isModeAssignSub,
    } = this.state;

    let assignedUserId = null;
    let subcontractorId = null;

    if (isModeAssignSub) {
      subcontractorId = subcontractor ? subcontractor.value : null;
    } else {
      assignedUserId = user ? user.value : null;
    }

    const params = {
      title: formValues.title,
      description: formValues.description,
      requestId: rfsId,
      tradeId: trade ? trade.value : null,
      roomId: room.value,
      itemToRepairId: itemRepair ? itemRepair.value : null,
      subcontractorId: subcontractorId,
      assignedUserId: assignedUserId,
      workOrderTypeId: wot ? wot.value : null,
      problemId: problem ? problem.value : null,
      appointmentDate: appointmentDate
        ? Moment(appointmentDate).format()
        : null,
      // attachments: uploadedFiles.map(f => ({url: f.Location, key: f.Key, fileName: f.name}))
    };

    this.props.dispatch({
      type: WorkOrderActionType.CREATE_WORK_ORDER_ASYNC,
      params: {
        data: params,
        isRedirectToEdit: false,
      },
      callback: (workorder) => {
        if (this.state.files.length > 0) {
          this.uploadAttachmentsToS3(this.state.files, workorder);
        } else {
          this.props.dispatch({
            type: WorkOrderActionType.CREATE_WORK_ORDER_SUCCESS,
            data: {
              isRedirect: true,
              refNo: workorder.refNo,
              workOrderProfile: workorder,
            },
          });
          this.props.dispatch({
            type: NotifyActionType.NOTIFY_SUCCESS,
            data: "Work order created",
          });
        }
      },
    });
  };

  uploadAttachmentsToS3 = (files, workOrder) => {
    let uploadedFiles = [];
    console.log("WorkorderID", workOrder);
    this.props.dispatch({
      type: WorkOrderActionType.SETUP_AWS_S3_ASYNC,
      params: { resourcePath: `work-order/${workOrder.refNo}` },
      callback: () => {
        files.map((file) => {
          this.props.dispatch({
            type: WorkOrderActionType.UPLOAD_FILE_WORK_ORDER_ASYNC,
            params: {
              file: file,
              config: this.props.WorkOrderCredentials,
            },
            callback: (status, result) => {
              if (status === true) {
                result.data.name = file.name;
                uploadedFiles.push(result.data);
                this.props.dispatch({
                  type: WorkOrderActionType.UPLOAD_TO_SERVER_ASYNC,
                  params: {
                    refNo: workOrder.refNo,
                    rfsId: workOrder.rfsRefNo,
                    data: {
                      url: result.data.Location,
                      key: result.data.Key,
                      fileName: result.data.name,
                    },
                  },
                  callback: (res) => {
                    console.log(
                      uploadedFiles.length,
                      files.length,
                      "uploadedFiles.length"
                    );
                    if (uploadedFiles.length === files.length) {
                      // callback(uploadedFiles);
                      this.props.dispatch({
                        type: WorkOrderActionType.CREATE_WORK_ORDER_SUCCESS,
                        data: {
                          isRedirect: true,
                          refNo: workOrder.refNo,
                          workOrderProfile: workOrder,
                        },
                      });
                      console.log("counter1", counter);
                      if (counter === 1) {
                        console.log("counter2", counter);
                        this.props.dispatch({
                          type: NotifyActionType.NOTIFY_SUCCESS,
                          data: "Work order created",
                        });
                        counter++;
                      }
                    }
                  },
                });
              }
            },
          });
        });
      },
    });
  };

  onDropOnAttachments = (droppedFiles) => {
    const { files } = this.state;

    //check maximum is 3 files
    if (files.length + droppedFiles.length > 3) {
      this.setState({ errorFile: "Maximum 3 files allowed." });
    } else {
      let errorFile = null;
      let currentFiles = [...files];

      // show error message when existing one or more file larger than 10MB
      droppedFiles.map(async (file) => {
        const fileExtention = file.name.split(".").pop();
        if (fileExtention === "heif" || fileExtention === "heic") {
          /*HEIF or HEIC file convert to jpeg with package*/
          let convertedFile = await ImageConvertor.convertImage(file);
          let replaceFileName = `${file.name.split(".")[0]}.jpeg`;
          const blobToFile = new File([convertedFile], replaceFileName);
          if (blobToFile.size > MAXIMUM_FILE_SIZE) {
            errorFile = "File size must not exceed 10MB.";
          } else {
            blobToFile["id"] = uuidv4();
            currentFiles.push(blobToFile);
            this.setState({
              files: currentFiles,
              errorFile: errorFile,
            });
          }
        } else {
          if (file.size > MAXIMUM_FILE_SIZE) {
            errorFile = "File size must not exceed 10MB.";
          } else {
            file["id"] = uuidv4();
            currentFiles.push(file);

            this.setState({
              files: currentFiles,
              errorFile: errorFile,
            });
          }
        }
      });
    }
  };
  onClickTrashIcon = (selectedFile) => {
    let currentFiles = [
      ...this.state.files.filter((f) => f.id !== selectedFile.id),
    ];

    this.setState({
      files: currentFiles,
      errorFile: null,
    });
  };

  renderRequestHomeOwner() {
    // const { RFSProfile } = this.state;

    return (
      <div className="form-group">
        <div className="col-sm-12">
          <span className="text-danger">
            This request is generated by <Translate translateKey="homeowner" />
          </span>
        </div>
      </div>
    );
  }

  toolTip() {
    return (
      <Tooltip className="in tooltip-siteone">
        <span>
          This feature is currently unavailable. Please contact your Super Admin
          for access
        </span>
      </Tooltip>
    );
  }

  renderNewWorkOrder() {
    const disabled =
      !this.state.room || this.state.error || this.state.isDisabled;
    console.log("Disabled button:", this.state);
    console.log(
      "Disabled value:",
      this.state.lotStatus ? false : true && disabled
    );
    return (
      <div
        className="work-order-info-wrapper box-form-siteone col-xs-12 col-lg-12 add-wo-form"
        style={{ padding: 0 }}
      >
        <div className="wo-general-info clearfix">
          <div className="row">
            <label
              className="col-sm-12 control-label form-siteone-label"
              style={{
                textTransform: "initial",
                fontSize: "16px",
                fontWeight: 500,
                marginBottom: "20px",
                color: "#c0c0c0",
              }}
            >
              Work order details
            </label>
          </div>
          <div className="row col-lg-12 col-sm-12">
            <div className="col-sm-6" style={{ paddingLeft: 0 }}>
              <label className="col-sm-12 control-label form-siteone-label">
                Work order type
              </label>
              <div className="col-sm-12">
                <Dropdown
                  onChange={(ref) => {
                    this.onSelectChange(ref, "wot");
                  }}
                  className="filestring-dropdown filter-dropdown"
                  onRemote={this.fetchSelectedWOT}
                  options={this.props.workOrderTypeList}
                  loading={this.state.isLoadingWorkOrderType}
                  optionLabel="text"
                  errorMessage="This information is required."
                  value={this.state.wot}
                  showClear={true}
                  name="workOrderType"
                  placeholder="-- Please select"
                  ref={(ref) => {
                    this.wotDropdown = ref;
                  }}
                  style={{ width: "100%", paddingLeft: 15 }}
                />
              </div>
            </div>
          </div>

          <div className="row col-sm-12">
            <div className="col-sm-6" style={{ paddingLeft: 0 }}>
              <label className="col-sm-12 control-label form-siteone-label">
                Location <span className="text-danger">*</span>
              </label>
              <div className="col-sm-12">
                <Dropdown
                  onChange={(ref) => {
                    this.onSelectChange(ref, "room");
                  }}
                  filter={true}
                  className="filestring-dropdown filter-dropdown"
                  onRemote={this.fetchSelectRoom}
                  options={this.props.RoomList}
                  optionLabel="text"
                  errorMessage="This information is required."
                  value={this.state.room}
                  loading={this.state.isLoadingLocation}
                  showClear={true}
                  name="room"
                  placeholder="-- Please select"
                  ref={(ref) => {
                    this.roomDropdown = ref;
                  }}
                  style={{ width: "100%", paddingLeft: 15 }}
                />
              </div>
            </div>
          </div>
          <div className="row col-sm-12">
            <div className="col-sm-6 select-trade">
              <label className="col-sm-12 control-label form-siteone-label">
                Trade
              </label>
              <div className="col-sm-12">
                <Dropdown
                  onChange={(ref) => {
                    this.onSelectChange(ref, "trade");
                  }}
                  filter={true}
                  className="filestring-dropdown filter-dropdown"
                  options={this.props.TradeList}
                  optionLabel="text"
                  errorMessage="This information is required."
                  onRemote={this.fetchSelectTrade}
                  value={this.state.trade}
                  loading={this.state.isLoadingTrade}
                  showClear={true}
                  name="trade"
                  placeholder="-- Please select"
                  ref={(ref) => {
                    this.tradeDropdown = ref;
                  }}
                  style={{ width: "100%", paddingLeft: 15 }}
                />
              </div>
            </div>
            <div className="col-sm-6 select-assigned" style={{ paddingTop: 3 }}>
              <div
                className="col-sm-12 control-label form-siteone-label"
                style={{ marginBottom: 5 }}
              >
                Assigned to
                <div
                  className="btn-group btn-group-sm wo-assign-btn-group"
                  role="group"
                >
                  <button
                    type="button"
                    className={
                      "btn btn-secondary " +
                      (this.state.isModeAssignSub ? "active" : "")
                    }
                    onClick={() => {
                      this.handleModeAssign("sub");
                    }}
                    disabled={!this.state.lotStatus}
                  >
                    subcontractor
                  </button>
                  <button
                    type="button"
                    className={
                      "btn btn-secondary " +
                      (!this.state.isModeAssignSub ? "active" : "")
                    }
                    onClick={() => {
                      this.handleModeAssign("user");
                    }}
                    disabled={!this.state.lotStatus}
                  >
                    internal user
                  </button>
                </div>
                {this.state.lotStatus ? null : (
                  <OverlayTrigger
                    placement="top"
                    overlay={this.toolTip()}
                    delayHide={10}
                    delayShow={500}
                  >
                    <span
                      style={{ paddingLeft: 10, paddingRight: 0 }}
                      className="fa fa-info-circle"
                    />
                  </OverlayTrigger>
                )}
              </div>
              <div className="col-sm-12" style={{ paddingRight: 0 }}>
                {this.state.isModeAssignSub ? (
                  <Dropdown
                    onChange={(ref) => {
                      this.onSelectChange(ref, "subcontractor");
                    }}
                    filter={true}
                    className="filestring-dropdown filter-dropdown"
                    onRemote={this.fetchSubcontractor}
                    options={
                      this.state.trade ? this.props.SubcontractorList : []
                    }
                    optionLabel="text"
                    errorMessage="This information is required."
                    value={this.state.subcontractor}
                    loading={this.state.isLoadingSubcontractor}
                    disabled={!this.state.trade || !this.state.lotStatus}
                    showClear={true}
                    name="subcontractor"
                    placeholder="-- Select a trade first"
                    ref={(ref) => {
                      this.subcontractorDropdown = ref;
                    }}
                    style={{ width: "100%", paddingLeft: 10 }}
                  />
                ) : (
                  this.renderInternalUserDropdown()
                )}
                {}
              </div>
            </div>
          </div>
          <div className="row col-sm-12">
            <div
              className="col-sm-6"
              style={{ paddingLeft: 0, paddingRight: 15 }}
            >
              <label className="col-sm-12 control-label form-siteone-label">
                Item to repair
              </label>
              <div className="col-sm-12">
                <Dropdown
                  onChange={(ref) => {
                    this.onSelectChange(ref, "itemRepair");
                  }}
                  filter={true}
                  className="filestring-dropdown filter-dropdown"
                  options={this.state.trade ? this.props.ItemRepairList : []}
                  optionLabel="text"
                  errorMessage="This information is required."
                  onRemote={this.fetchSelectItemRepair}
                  loading={this.state.isLoadingItemToRepair}
                  value={this.state.itemRepair}
                  disabled={!this.state.trade}
                  showClear={true}
                  name="itemToRepair"
                  placeholder="-- Select a trade first"
                  ref={(ref) => {
                    this.itemRepairDropdown = ref;
                  }}
                  style={{ width: "100%", paddingLeft: 15 }}
                />
              </div>
            </div>
            <div className="col-sm-6" style={{ paddingLeft: 0 }}>
              <label className="col-sm-12 control-label form-siteone-label">
                Problem
              </label>
              <div className="col-sm-12">
                <Dropdown
                  onChange={(ref) => {
                    this.onSelectChange(ref, "problem");
                  }}
                  className="filestring-dropdown filter-dropdown"
                  options={this.state.itemRepair ? this.props.ProblemList : []}
                  optionLabel="text"
                  errorMessage="This information is required."
                  onRemote={this.fetchSelectProblem}
                  loading={this.state.isLoadingProblem}
                  value={this.state.problem}
                  disabled={!this.state.itemRepair}
                  showClear={true}
                  name="problem"
                  ref={(ref) => {
                    this.problemDropdown = ref;
                  }}
                  placeholder="-- Select an item to repair first"
                  style={{ width: "100%", paddingLeft: 15 }}
                />
              </div>
            </div>
          </div>

          <div className="row col-sm-12 form-group" style={{ marginBottom: 5 }}>
            <label className="col-sm-12 control-label form-siteone-label">
              Summary<span className="text-danger"> *</span>
            </label>
            <div className="col-sm-12" style={{ padding: "0 15px" }}>
              <Input
                type="text"
                name="title"
                ref="title"
                className="form-control"
                max="200"
                maxLength="200"
                errorMsg="Summary is maximum 200 characters"
                validations={[Vali.required, Vali.maxlength]}
              />
            </div>
          </div>

          <div className="row col-sm-12 form-group" style={{ marginBottom: 5 }}>
            <label className="col-sm-12 control-label form-siteone-label">
              Description
              <span className="text-danger" />
            </label>
            <div className="col-sm-12" style={{ padding: "0 15px" }}>
              <Textarea
                className="form-control"
                name="description"
                ref="description"
                max="1000"
                maxLength="1000"
                errorMsg="Description is maximum 1000 characters"
                style={{ height: 130 }}
                validations={[Vali.maxlength]}
              />
            </div>
          </div>

          <div className="row col-sm-12 form-group">
            <label className="col-sm-12 control-label form-siteone-label">
              Appointment
            </label>
            <div className="col-sm-4" style={{ padding: "0 15px" }}>
              <Datetime
                ref={this.appointmentDateRef}
                key={this.appointmentDateRef.current}
                initialViewDate={Moment(new Date()).set({ hour: 9, minute: 0 })}
                name="appointmentDate"
                inputProps={{ placeholder: "mm/dd/yyyy hh:mm" }}
                value={this.state.appointmentDate}
                onChange={this.onChangeAppointmentDate}
                closeOnSelect={true}
                isValidDate={isValidAppointmentDate}
                input={true}
                renderInput={this.renderInput}
              />
              {this.state.error && (
                <span className="text-danger" style={{ fontSize: 12 }}>
                  {this.state.error}
                </span>
              )}
            </div>
          </div>

          <div className="row col-sm-12 form-group">
            <label className="col-sm-12 control-label form-siteone-label">
              Attachment
            </label>
            <Dropzone
              disableClick
              style={{ position: "initial" }}
              ref={(ref) => {
                this.dropzoneRef = ref;
              }}
              onDrop={this.onDropOnAttachments}
            >
              <span
                className="add-new-attachment-label"
                style={{ marginLeft: 15 }}
                onClick={(e) => this.dropzoneRef.open()}
              >
                + Add new attachment
              </span>
            </Dropzone>
            {this.state.errorFile && (
              <div
                className="text-danger"
                style={{ marginLeft: 15, fontSize: 12 }}
              >
                {this.state.errorFile}
              </div>
            )}

            {this.state.files.map((f) => (
              <div key={f.name} style={{ marginLeft: 15 }}>
                <span style={{ fontStyle: "italic" }}>{f.name}</span>
                <i
                  className="fa fa-trash"
                  style={{ cursor: "pointer", marginLeft: 15 }}
                  onClick={() => this.onClickTrashIcon(f)}
                />
              </div>
            ))}
          </div>

          <ul className="wo-detail-bottom-btn">
            <li>
              <span
                className="btn btn-primary btn-siteone-default"
                onClick={this.handleCancel}
              >
                Cancel
              </span>
            </li>
            <li>
              <Submit
                className="btn btn-primary btn-submit btn-siteone"
                disabled={disabled}
              >
                Create
              </Submit>
            </li>
            <li>
              {!this.state.lotStatus ? (
                <OverlayTrigger placement="top" overlay={this.toolTip()}>
                  <div>
                    <Submit
                      className="btn btn-primary btn-siteone btn-siteone-orange"
                      type="button"
                      disabled={!this.state.lotStatus || disabled}
                      onClick={this.onClickCreatenSendButton}
                    >
                      Create & Send
                    </Submit>
                  </div>
                </OverlayTrigger>
              ) : (
                <Submit
                  className="btn btn-primary btn-siteone btn-siteone-orange"
                  type="button"
                  disabled={!this.state.lotStatus || disabled}
                  onClick={this.onClickCreatenSendButton}
                >
                  Create & Send
                </Submit>
              )}
            </li>
            <li>
              <CheckBoxSingle
                // style={{marginTop: 0, marginBottom: 20}}
                checked={this.state.isCheckAnotherProblem}
                ref={(c) => {
                  this.check = c;
                }}
                name="checkForCreateAnother"
                label="Also create another"
                className="checkbox-default noteTitle"
                onChecked={this.onChecked}
              />
            </li>
          </ul>
        </div>
      </div>
    );
  }

  render() {
    const { ManagerStore } = this.props;

    if (
      ManagerStore &&
      ManagerStore.RFSProfile &&
      ManagerStore.RFSProfile.project
    ) {
      return (
        <div className="rfs-detail add-new-work-order">
          <div className="page-title clearfix">
            <h2 className="pull-left">Add new work order</h2>
          </div>
          <ul className="breadcrumb">
            <li>
              <Link to={"/request-for-services"}>Requests for service</Link>
            </li>
            <li>
              <Link to={`/request-for-services/${this.state.rfsId}`}>
                RFS # {this.state.rfsId}
              </Link>
            </li>
            <li className="breadcrumb-siteone-li">Add new work order</li>
          </ul>
          <div className="wrapper">
            <RFSInfo
              RFSInformation={ManagerStore.RFSProfile}
              location={this.props.location}
              history={this.props.history}
              mode="rfs"
            />
            <div className="wrapper-form">
              <Form
                className="form-horizontal"
                ref={(ref) => {
                  this.form = ref;
                }}
                onSubmit={this.onSubmit}
              >
                {this.renderNewWorkOrder()}
              </Form>
            </div>
          </div>
        </div>
      );
    } else {
      return null;
    }
  }
}

const mapStateToProps = (state) => {
  return {
    UserProfile: state.UserStore.UserProfile,
    ManagerStore: state.RFSStore,
    workOrderTypeList: state.WorkOrderTypesStore.WOTList,
    TradeList: state.LotStore.TradeList,
    ItemRepairList: state.TradeStore.ItemRepairList,
    ProblemList: state.ItemRepairStore.ProblemList,
    RoomList: state.LotStore.RoomList,
    SubcontractorList: state.SubcontractorStore.SubcontractorList,
    UserList: state.ProjectStore.UserSelectList,
    IsRedirectToEdit: state.WorkOrderReducer.IsRedirectToEdit,
    WorkOrderCredentials: state.WorkOrderReducer.Credentials,
    DefaultConfigList: state.CustomorderStore.DefaultConfigList,
  };
};

export default connect(mapStateToProps)(AddWorkOrder);



// WEBPACK FOOTER //
// ./src/Work-Orders/Containers/add-work-order.js